import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Grid
} from '@mui/material';
import {
  StyledMainContainer,
  StyledHeaderWrapper,
  StyledPageTitle,
  StyledTableContainer,
  StyledTableHeaderCell,
  StyledPaper,
  disabledInputBlackTextSx
} from './StyleComponents';

import { useParams } from 'react-router-dom';
import Header from './Header';
import api from './api';

function RutinaDetail() {
  const [preguntasTexto, setPreguntasTexto] = useState({});
  const preguntasCacheRef = useRef({});
  const preguntasMetaRef = useRef({}); // { [preguntaId]: { orden, pregunta_created_at } }
  const [metaVersion, setMetaVersion] = useState(0); // fuerza recalcular orden cuando llegan metas


  const { id } = useParams();
  const [formData, setFormData] = useState({
    nombre: '',
    determinante: '',
    planta: '',
    supervisor: '',
    coordinador: '',
    fecha_respuestas: '',
    semaforo: '',
    preguntas: [],
  });

  useEffect(() => {
    const fetchRutinaDetail = async () => {
      try {
        const response = await api.get(`/rutinas/${id}`);
        const data = response.data;

        console.log("dasafaf");
        console.log(data)

        const rutinaAdaptada = {
          nombre: data.nombre || '',
          determinante: data.planta?.determinante || '---',
          planta: data.planta?.nombre || '---',
          supervisor: data.supervisor?.nombre || '---',
          coordinador: data.coordinador?.nombre || '---',
          fecha_respuestas: data.fecha_inicio?.slice(0, 10) || '',
          semaforo: data.semaforo || '',
          preguntas: (data.respuestas || []).map((res, idx) => ({
          id: res.id,
          pregunta: res.pregunta_rutina_id,
          respuesta: res.respuesta || '',
          observaciones: res.observaciones || '',
          rango: res.es_valida !== null ? (res.es_valida ? 'Sí' : 'No') : '---',
          _idx: idx, // orden original recibido (fallback estable)
          respuesta_created_at: res.created_at || null // si tu backend lo manda
        }))

        };

        setFormData(rutinaAdaptada);
      } catch (error) {
        console.error('Error al cargar detalle de rutina:', error);
      }
    };

    fetchRutinaDetail();
  }, [id]);

  const getSemaforoColor = (semaforo) => {
    switch (semaforo?.toLowerCase()) {
      case 'verde':
        return '#4CAF50';
      case 'amarillo':
        return '#FFC107';
      case 'rojo':
        return '#F44336';
      default:
        return 'transparent';
    }
  };

  const semaforoColor = getSemaforoColor(formData.semaforo);

  useEffect(() => {
  const chunked = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const fetchFaltantes = async () => {
    // 1) IDs únicos que realmente necesitas (vienen en formData.preguntas)
    const idsNecesarios = Array.from(
      new Set(
        (formData.preguntas || [])
          .map(p => p.pregunta) // aquí guardaste el UUID de la pregunta en "pregunta"
          .filter(Boolean)
      )
    );

    // 2) Calcula cuáles faltan en cache
    const faltantes = idsNecesarios.filter(id => !preguntasCacheRef.current[id]);
    if (faltantes.length === 0) {
      // Ya está todo cacheado
      setPreguntasTexto({ ...preguntasCacheRef.current });
      return;
    }

    try {
      // 3) Baja en lotes para evitar demasiadas requests simultáneas
      const grupos = chunked(faltantes, 50); // ajusta el tamaño si quieres
      for (const grupo of grupos) {
        const respuestas = await Promise.all(
          grupo.map(id => api.get(`/preguntas_rutinas/${id}`))
        );
       respuestas.forEach(res => {
           const { id, pregunta, orden, posicion, created_at } = res.data; // usa lo que exista
           preguntasCacheRef.current[id] = pregunta;
            const parsedOrden = Number(orden ?? posicion);
         preguntasMetaRef.current[id] = {
           orden: Number.isFinite(parsedOrden) ? parsedOrden : null,
           pregunta_created_at: created_at || null,
         };
         setMetaVersion(v => v + 1);
                });
         setPreguntasTexto({ ...preguntasCacheRef.current });
         setMetaVersion(v => v + 1); // avisa que hay nueva metadata para re-ordenar
      }
    } catch (err) {
      console.error('Error al cargar preguntas por ID:', err);
    }
  };

  if ((formData.preguntas || []).length > 0) {
    fetchFaltantes();
  }
}, [formData.preguntas]);


const comparePreguntas = (a, b) => {
  const ma = preguntasMetaRef.current[a.pregunta];
  const mb = preguntasMetaRef.current[b.pregunta];

   // 1) Orden explícito numérico (orden/posicion) — si uno tiene y el otro no, va primero el que SÍ tiene
 const ao = ma?.orden;
 const bo = mb?.orden;
 if (ao != null || bo != null) {
   if (ao == null) return 1;         // b tiene orden, a no
   if (bo == null) return -1;        // a tiene orden, b no
   if (ao !== bo) return ao - bo;    // ambos tienen orden → orden asc
 }
  // 2) Fecha de creación de la PREGUNTA
  if (ma?.pregunta_created_at && mb?.pregunta_created_at) {
    return new Date(ma.pregunta_created_at) - new Date(mb.pregunta_created_at);
  }
  // 3) Fecha de creación de la RESPUESTA
  if (a.respuesta_created_at && b.respuesta_created_at) {
    return new Date(a.respuesta_created_at) - new Date(b.respuesta_created_at);
  }
  // 4) Fallback: índice original recibido
  return (a._idx ?? 0) - (b._idx ?? 0);
};

// Se recalcula cuando cambia la lista o llega nueva metadata
const preguntasOrdenadas = React.useMemo(() => {
  return (formData.preguntas || []).slice().sort(comparePreguntas);
}, [formData.preguntas, metaVersion]);



  return (
    <StyledMainContainer>
      <Header />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', mb: 3 }}>
        <Typography variant="h5" component="h2">
          Detalle Respuestas de Rutina
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Rutinas &gt; Detalle rutina
        </Typography>
      </Box>

      <Paper elevation={0} sx={{ p: 2, mb: 4, border: '1px solid #e0e0e0', borderRadius: '4px' }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Fecha respuestas"
              value={formData.fecha_respuestas}
              variant="outlined"
              size="small"
              disabled
              sx={disabledInputBlackTextSx}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Semáforo"
              value={formData.semaforo}
              variant="outlined"
              size="small"
              disabled
              sx={{
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                  color: 'black',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: semaforoColor,
                },
                '& .MuiInputBase-root.Mui-disabled': {
                  backgroundColor: semaforoColor + '33',
                },
              }}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Nombre"
              value={formData.nombre}
              variant="outlined"
              size="small"
              disabled
              sx={disabledInputBlackTextSx}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Determinante"
              value={formData.determinante}
              variant="outlined"
              size="small"
              disabled
              sx={disabledInputBlackTextSx}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Planta"
              value={formData.planta}
              variant="outlined"
              size="small"
              disabled
              sx={disabledInputBlackTextSx}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Supervisor"
              value={formData.supervisor}
              variant="outlined"
              size="small"
              disabled
              sx={disabledInputBlackTextSx}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6 }}>
            <TextField
              fullWidth
              label="Coordinador"
              value={formData.coordinador}
              variant="outlined"
              size="small"
              disabled
              sx={disabledInputBlackTextSx}
            />
          </Grid>
        </Grid>
      </Paper>

      <StyledTableContainer component={StyledPaper} elevation={1}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell>Pregunta</StyledTableHeaderCell>
              <StyledTableHeaderCell>Respuesta</StyledTableHeaderCell>
              <StyledTableHeaderCell>Observaciones</StyledTableHeaderCell>
              <StyledTableHeaderCell>Indicador en rango</StyledTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {preguntasOrdenadas.map((pregunta) => (
                console.log("Current pregunta object:", pregunta),
              <TableRow key={pregunta.id}>
                <TableCell sx={{
                        maxWidth: 200,
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                        '&::-webkit-scrollbar': { height: 6 },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: 3 },
                    }}
                    >
                {preguntasTexto[pregunta.pregunta] || '---'}
                </TableCell>
                <TableCell sx={{
                        maxWidth: 200,
                        overflowX: 'auto',
                        whiteSpace: 'nowrap',
                        '&::-webkit-scrollbar': { height: 6 },
                        '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: 3 },
                    }}
                    >
                {pregunta.respuesta}
                </TableCell>
                
                <TableCell sx={{ maxWidth: 200, overflow: 'auto', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {pregunta.observaciones}
                </TableCell>
                <TableCell sx={{ maxWidth: 200, overflow: 'auto', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                {pregunta.rango}
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </StyledMainContainer>
  );
}

export default RutinaDetail;
